/*                                                   */
import { o_global } from "@gr-common/body/namespaces";
import breakpointInstance from "./breakpoint";

o_global.breakpoint ||= breakpointInstance;

/*                                                  */
o_global.device ||= {} as never;
(o_global.device as any).breakpoint ||= window.o_global.breakpoint;
